import { useState, useEffect } from "react";
import "./CountdownSection.css";

function CountdownSection() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    // drop date is 18:30pm 4 apr GMT
    const dropDate = new Date("2026-04-04T18:30:00Z");
    const calculateTimeLeft = () => {
      const now = new Date();
      const timeDiff = dropDate - now;

      if (timeDiff > 0) {
        setTimeLeft({
          days: Math.floor(timeDiff / (1000 * 60 * 60 * 24)),
          hours: Math.floor((timeDiff / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((timeDiff / (1000 * 60)) % 60),
          seconds: Math.floor((timeDiff / 1000) % 60),
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="countdown-section" data-logo-color="gold">
      <h2 className="countdown-title">Tickets have already Dropped!</h2>
      <div className="countdown-timer">
        <p className="countdown-subtitle">The Ball will start in...</p>
        <div className="timer">
          <div className="time-segment">
            <span className="number">
              {String(timeLeft.days).padStart(2, "0")}
            </span>
            <span className="label">Days</span>
          </div>
          <div className="time-separator">:</div>
          <div className="time-segment">
            <span className="number">
              {String(timeLeft.hours).padStart(2, "0")}
            </span>
            <span className="label">Hours</span>
          </div>
          <div className="time-separator">:</div>
          <div className="time-segment">
            <span className="number">
              {String(timeLeft.minutes).padStart(2, "0")}
            </span>
            <span className="label">Minutes</span>
          </div>
          <div className="time-separator">:</div>
          <div className="time-segment">
            <span className="number">
              {String(timeLeft.seconds).padStart(2, "0")}
            </span>
            <span className="label">Seconds</span>
          </div>
        </div>
      </div>
      {/* redirect to ticket purchase page */}
      <a
        href="https://buytickets.at/computerscienceball2025/2062693"
        className="buy-tickets-link"
      >
        <b className="buy-tickets-btn"> Buy tickets </b>
      </a>
      {/* footer with author credits */}
      <div className="countdown-footer">
        <p>
          Website designed and developed by{" "}
          <a
            href="https://linktr.ee/anastasiamartinson"
            target="_blank"
            rel="noopener noreferrer"
          >
            Anastasia Martinson
          </a>
        </p>
      </div>
    </section>
  );
}

export default CountdownSection;
